import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getMailList } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class cmsMails extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              mailList: [],
        };

        this.getList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_maili', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });


    }


    getList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getMailList(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            mailList: res.data
            
          });
        } else {
          this.setState({
            mailList: [],
          });
        }
      });
    }    

    render() {

        const { mailList } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Mails</h4>
                 
 
                  <div class="float-right"><a href="/cms/addmail" class="btn btn-primary btn-sm">Add New</a></div>
                 

                  <div class="table-responsive pt-3">
                     <table id="tablebw">
                      <thead  class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>

                           <th>
                            <strong>Template</strong>
                          </th>
                          
                           
                          <th>
                            <strong>Date</strong>
                          </th>
                          <th>
                            <strong>By</strong>
                          </th>
                                                 
                          <th>
                            <strong>Status</strong>
                          </th>
                          
                          <th>
                            <strong>Action</strong>
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                      {mailList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          
                          <td>
                           {item.mail_template}
                          </td>
                          <td>
                           {item.created_date}
                          </td>
                          <td>
                            {item.created_by}
                          </td>
                           
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                            
                          <td dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default cmsMails;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsMails.jsx